import { gql } from '@apollo/client';

export const DELETE_SURVEY_MUTATION = gql`
  mutation DeleteSurvey($id: Int!) {
    p {
      deleteSurvey(id: $id) {
        success
        message {
          code
          message
        }
        content
      }
    }
  }
`;
